import * as React from 'react'
import { useEffect, useState } from 'react'
import { reportRaptorMetrics } from '@/common/SLRaptor'
import { InputProps, NormalizedSingleFrameProps } from './wrapperTypes'
import { taskCallback } from './request'
import ErrorBoundary from './ErrorBoundary'
import { RESOURCE_ERROR_BOUNDARY } from './const'

export const translateProps = (Comp: React.ComponentType<NormalizedSingleFrameProps>, raptorKey?: string) => {
  const HOC = (inputProps: InputProps) => {
    const { data, id: resourceId, ...otherProps } = inputProps
    if (!data) {
      return null
    }

    if (data?.length <= 0) {
      return null
    }
    const { id: campaignId, ...props } = data[0]

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      if (props.launchTaskShowState) {
        taskCallback({
          channelId: props?.channelId,
          launchTaskId: campaignId,
        })
      }
      reportRaptorMetrics(
        { MKT_RESOURCE_SHOW: 1 },
        {
          resourceId: String(resourceId),
          campaignId: String(campaignId),
        },
      )
    }, [])

    return (
      <ErrorBoundary
        raptorKey={raptorKey || RESOURCE_ERROR_BOUNDARY}
        tags={{
          resourceId: String(resourceId),
          campaignId: String(campaignId),
        }}
      >
        <Comp resource_id={resourceId} {...otherProps} props={props} campaign_id={campaignId} />
      </ErrorBoundary>
    )
  }

  return HOC
}

export default translateProps
